<nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-clear">
    <a class="nav-item navbar-brand" routerLink="/">
      <img src="assets/img/logo_zeeker_blanco.png" alt="Zeeker Solutions">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup"
            aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <a class="nav-item nav-link" routerLink="quienes-somos" routerLinkActive="active-nav-item">¿QUIÉNES SOMOS?</a>
        <a class="nav-item nav-link" routerLink="servicios" routerLinkActive="active-nav-item">SERVICIOS</a>
        <a class="nav-item nav-link" routerLink="productos" routerLinkActive="active-nav-item">ONBOARDING</a>
        <a class="nav-item nav-link" routerLink="proyectos" routerLinkActive="active-nav-item">PROYECTOS</a>
        <!-- <a class="nav-item nav-link" href="https://blogzeeker.wpcomstaging.com/" target="_blank">BLOG</a> -->
        <a class="nav-item nav-link" routerLink="talento" routerLinkActive="active-nav-item">TALENTO</a>
        <!-- <a class="nav-item nav-link" routerLink="kit-digital" routerLinkActive="active-nav-item">KIT DIGITAL</a> -->
        <a class="nav-item nav-link" routerLink="contacto" routerLinkActive="active-nav-item">CONTACTO</a>
      </div>
    </div>
</nav>
